import { Box, Container, Typography } from '@mui/material';
import { Outlet } from 'react-router';

const footerLabel = `© ${new Date().getFullYear()} Morgan, Lewis & Bockius LLP. Morgan Lewis is a registered trademark of Morgan, Lewis & Bockius LLP. All rights reserved.`;

const EngagementLetterDatabaseLayout = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
    <Container component="main" maxWidth="xl" sx={{ py: { xs: 3, md: 4 }, flexGrow: 1 }}>
      <Outlet />
    </Container>

    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'grey.100',
      }}
    >
      <Container maxWidth="xl">
        <Typography variant="body2" color="text.secondary" align="center">
          {footerLabel}
        </Typography>
      </Container>
    </Box>
  </Box>
);

export default EngagementLetterDatabaseLayout;
